import gql from 'graphql-tag';
import * as React from 'react';
import * as Firebase from 'firebase';
import { ApolloConsumer } from 'react-apollo';
import { ApolloClient } from 'apollo-boost';
import { withRouter, RouteComponentProps } from 'react-router-dom';

import withStyles, {
  WithStyles,
  StyleRulesCallback
} from '@material-ui/core/styles/withStyles';

import {
  Paper,
  Typography,
  TextField,
  Button,
  Snackbar,
  IconButton
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

import { firebaseLogin } from '../services';

const styles: StyleRulesCallback = theme => ({
  root: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
    height: '100vh',
    backgroundColor: theme.palette.primary.main,
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    flexBasis: 440,
    margin: '32px 0 80px'
  },
  title: {
    fontSize: 30,
    marginBottom: 16,
    fontWeight: 400,
    textAlign: 'center'
  },
  body: {
    borderRadius: 0,
    padding: theme.spacing.unit * 5
  },
  primaryButton: {
    textTransform: 'none',
    borderRadius: 0,
    border: `1px solid ${theme.palette.primary.main}`,
    color: '#000',
    fontSize: 16
  },
  secondaryButton: {
    textTransform: 'none',
    borderRadius: 0,
    fontSize: 16
  },
  dialogFooter: {
    margin: '32px -20px 8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  close: {
    width: theme.spacing.unit * 4,
    height: theme.spacing.unit * 4,
  }
});

const GQL = gql`
  query AuthenticateAdministrator($account: String!) {
    authenticateAdministrator(account: $account) {
      customToken
    }
  }
`;

type Props = WithStyles & RouteComponentProps<any>;

interface State {
  email: string;
  password: string;
  account: string;
  loading: boolean;
  snackbar: string | null;
}

class Administrator extends React.Component<Props, State> {
  state = {
    email: '',
    password: '',
    account: '',
    loading: false,
    snackbar: null
  };

  handleLogin = async (event: any, client: ApolloClient<any>) => {
    event.preventDefault();
    this.setState({loading: true});
    const { email, password, account } = this.state;
    try {
      await firebaseLogin(email, password);
      const auth = Firebase.auth();
      const token = auth && auth.currentUser ? await auth.currentUser.getIdToken() : '';
      const { data } = await client.query<any>({
        query: GQL,
        variables: { account },
        context: {
          headers: {
            authorization: token
          }
        }
      });
      await Firebase.auth().signInWithCustomToken(data.authenticateAdministrator.customToken);
      this.props.history.push('/');
    } catch (err) {
      console.error(err);
      this.setState({
        snackbar: 'Contraseña o email inválidos'
      });
    }
    this.setState({loading: false});
  }

  render() {
    const { classes } = this.props;
    return (
      <ApolloConsumer>
        {client =>
          <main className={classes.root}>
            <div className={classes.container}>
              <Paper className={classes.body}>
                <form
                  action="#"
                  onSubmit={event => this.handleLogin(event, client)}
                >
                  <Typography variant="display1" className={classes.title}>
                    Ingresar a Pirwa
                  </Typography>

                  <TextField
                    fullWidth={true}
                    required={true}
                    name="email"
                    type="email"
                    label="Email"
                    margin="dense"
                    value={this.state.email}
                    onChange={e => this.setState({email: e.target.value})}
                    disabled={this.state.loading}
                  />

                  <TextField
                    fullWidth={true}
                    required={true}
                    name="password"
                    type="password"
                    label="Contraseña"
                    margin="dense"
                    value={this.state.password}
                    onChange={e => this.setState({password: e.target.value})}
                    disabled={this.state.loading}
                  />

                  <TextField
                    fullWidth={true}
                    required={true}
                    name="account"
                    type="email"
                    label="Cuenta"
                    margin="dense"
                    value={this.state.account}
                    onChange={e => this.setState({account: e.target.value})}
                    disabled={this.state.loading}
                  />

                  <Button
                    type="submit"
                    color="primary"
                    className={classes.primaryButton}
                    style={{marginTop: 32}}
                    disabled={this.state.loading}
                    fullWidth={true}
                  >
                    Ingresar
                  </Button>
                </form>
              </Paper>
              <Snackbar
                anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                open={!!this.state.snackbar}
                autoHideDuration={6000}
                onClose={() => this.setState({snackbar: null})}
                message={<span>{this.state.snackbar || ''}</span>}
                action={
                  <IconButton
                    color="inherit"
                    className={classes.close}
                    onClick={() => this.setState({snackbar: null})}
                  >
                    <CloseIcon />
                  </IconButton>
                }
              />
            </div>
          </main>
        }
      </ApolloConsumer>
    );
  }
}

export default withStyles(styles)(withRouter(Administrator));



// WEBPACK FOOTER //
// ./src/containers/Administrator.tsx